import React from 'react';
import { GatsbyImage } from "gatsby-plugin-image"
import { Waves } from '../components';
import { Button } from '../components';

const SimpleHeroSection = ({ title, subtitle, subtitle1, blueBgImageData, buttonText, page }) => (
    <div className="grid grid-cols-12 w-full h-full relative m-0 p-0">
        <GatsbyImage
            className="absolute w-full h-full"
            style={{ position: "absolute", zIndex: -1 }}
            image={blueBgImageData}
            alt="Background Image"
        />
        <div className="col-span-12  py-24 px-8 md:px-0 mb-12 text-center">
            <h1 className="text-4xl text-white font-bold mb-2">{title}</h1>
            <h3 className="text-white font-light text-xl">{subtitle}</h3>
            {["thank-you", "Page404"].includes(page) ? (
                <>
                    <h3 className="text-white font-light text-xl mb-6">{subtitle1}</h3>
                    <Button color='whiteTransparent' href='/'>
                        {buttonText}
                    </Button>
                </>
            ) : null}
        </div>
        <Waves />
    </div>
);

export default SimpleHeroSection;